/**
 * «Здесь нужна физическая клавиатура» (Type2X_MASTER_PROMPT.md §7).
 *
 * Не запрет и не ошибка: тренажёр не отказывается работать — он объясняет,
 * чего ему не хватает, и говорит, что с телефона всё-таки можно. Нажатие с
 * подключённой клавиатуры снимает сообщение само, поэтому кнопки «я всё же с
 * клавиатурой» здесь нет: нажать любую клавишу и есть это действие.
 *
 * «С телефона всё-таки можно» — это ТЗ UX-15, и выполнено оно не целиком.
 * Прогресс, план и словарь ошибок с телефона открываются: приложение одно и
 * то же, экраны достижений, отчёта и «Моих ошибок» доступны без клавиатуры.
 * Планшет с внешней клавиатурой поддержан тем же признаком — определяется
 * клавиатура, а не ширина экрана. Напоминаний в продукте нет вовсе: ни
 * уведомлений, ни писем о пропущенном дне. Это записано, а не исправлено
 * походя: напоминания — отдельная функция со своим согласием и своим каналом
 * доставки (STATUS §7).
 */

import type { Translate } from '@type2x/i18n';

import { useKeyboardPresence } from './keyboard-presence.js';

/**
 * Сообщение, если печатать нечем; иначе ничего.
 *
 * Решение о показе принимается здесь, а не у каждого вызывающего: иначе
 * условие живёт в трёх местах и в одном из них однажды разойдётся.
 */
export function KeyboardNotice({ t }: { readonly t: Translate }): React.JSX.Element | null {
  if (useKeyboardPresence() === 'physical') return null;

  return (
    <aside className="t2x-keyboard-note" role="note">
      <p className="t2x-keyboard-note__title">{t('keyboard.requiredTitle')}</p>
      <p>{t('keyboard.requiredBody')}</p>
      <p className="t2x-muted">{t('keyboard.requiredWorks')}</p>
    </aside>
  );
}
